import * as Types from '../../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type FooterMutationVariables = Types.Exact<{
  playFooter: Types.PlayFooterInput;
}>;

export type FooterMutation = { playFooter: string };

export const FooterMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FooterMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'playFooter' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PlayFooterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'playFooter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'playFooter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'playFooter' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FooterMutation, FooterMutationVariables>;
